module.exports = __webpack_public_path__ + "assets/img/34_878.e77a3ad4.jpg";